import axios from "axios";
import { CreateAppoinmentDTO, GetAppoinmentDTO } from "../../dtos/appoinments";
import {
  AddAttachmentDTO,
  CancelAppointmentByDateDTO,
  AddExpensesDTO,
  AddNotesDTO,
  ChangeAppointmentStatusDTO,
  DeleteAppointmentDTO,
  DeleteAttachmentDTO,
  GetAppointmentHistoryDTO,
  DeleteReferralDTO,
  ConfirmAppointmentBookingDTO,
  SendSmsDTO,
  SendSpecificMesDTO,
  SendEmailDTO,
  SendBulkEmailDTO,
  SendOtp,
  ChangePaymentStatusDTO,
  AddPLabtestDTO,
  AddProcedureDTO,
  EditLabTesteDTO,
  EditProcedureDTO,
  DeleteLabTestDTO,
  DeleteProcedureDTO,
  GetAllClinicPatientsDTO,
  PaymentAddDTO,
} from "../../dtos/prescription";

// Get DoctoR Refferals
const getDoctorRefferalsRequest = async () => {
  const { data } = await axios.get( `/api/referral/doctor/get`);
  return data;
};

// Get Cancel appointment request
const getCancelAppointmentRequest = async () => {
  const { data } = await axios.get(
    `/api/admin/appointment/cancel/requests`
  );
  return data;
};

// Get Appointments
const getAllAppointments = async (dto: GetAppoinmentDTO) => {
  const { data } = await axios.get(
     `/api/admin/appointment/get/all?date=${dto.date}`
  );
  return data;
};

const getNewlyBookedAppointments = async (dto: GetAppoinmentDTO) => {
  const { data } = await axios.get(
     `/api/admin/appointment/get/bookings/all?date=${dto.date}`
  );
  return data;
};

const createAppointment = async (dto: CreateAppoinmentDTO) => {
  const { data } = await axios.post(
     "/api/appointment/create",
    dto
  );
  return data;
};

const changeAppointmentStatus = async (dto: ChangeAppointmentStatusDTO) => {
  const { data } = await axios.post(
     `/api/admin/appointment/status/change`,
    dto
  );
  return data;
};
const changePaymentStatus = async (dto: ChangePaymentStatusDTO) => {
  const { data } = await axios.post(
     `/api/admin/appointment/payment/status/change`,
    dto
  );
  return data;
};

const confirmAppointmentBooking = async (dto: ConfirmAppointmentBookingDTO) => {
  const { data } = await axios.post(
     `/api/admin/appointment/offline-doc/confirm-booking`,
    dto
  );
  return data;
};
const deleteAppointment = async (dto: DeleteAppointmentDTO) => {
  const { data } = await axios.post(
     `/api/admin/appointment/delete`,
    dto
  );
  return data;
};
//////doc refereal Api
const deleteReferalAppointment = async (dto: DeleteReferralDTO) => {
  const { data } = await axios.delete(
     `/api/referral/delete?phone_number=${dto.phone_number}`
  );
  return data;
};

const addAttachment = async (dto: AddAttachmentDTO) => {
  const { data } = await axios.post(
     "/api/appointment/attachment/add",
    dto
  );
  return data;
};
const getAttachments = async (appointmentId: string) => {
  const { data } = await axios.get(
    
      `/api/appointment/attachment/get?appointment_id=${appointmentId}`
  );
  return data;
};
const deleteAttachments = async (dto: DeleteAttachmentDTO) => {
  const { data } = await axios.delete(
    
      `/api/appointment/attachment/delete?appointment_id=${dto.appointment_id}&patient_id=${dto.patient_id}&file_name=${dto.file_name}`
  );
  return data;
};
const appoinmentHistory = async (dto: GetAppointmentHistoryDTO) => {
  const { data } = await axios.get(
    
      `/api/appointment/history?patient_id=${dto.patient_id}&dr_id=${dto.dr_id}`
  );
  return data;
};

const addNotes = async (dto: AddNotesDTO) => {
  const { data } = await axios.post(
     "/api/appointment/notes/add",
    dto
  );
  return data;
};
const getNotes = async (appointmentId: string) => {
  const { data } = await axios.get(
     `/api/appointment/notes/view?appointment_id=${appointmentId}`
  );
  return data;
};
const getInvoice = async (appointmentId: string) => {
  const { data } = await axios.get(
    
      `/api/appointment/invoice/get?appointment_id=${appointmentId}`
  );
  return data;
};
const addExpenses = async (dto: AddExpensesDTO) => {
  const { data } = await axios.post(
     `/api/appointment/expenses/add`,
    dto
  );
  return data;
};
const sendSms = async (dto: SendSmsDTO) => {
  const { data } = await axios.post(
     `/api/admin/send/bulk-sms`,
    dto
  );

  return data;
};
const sendEmail = async (dto: SendBulkEmailDTO) => {
  const { data } = await axios.post(
     `/api/admin/send/email`,
    dto
  );

  return data;
};
const sendBulkEmail = async (dto: SendEmailDTO) => {
  const { data } = await axios.post(
     `/api/admin/send/bulk-email`,
    dto
  );

  return data;
};
const sendSpecificSms = async (dto: SendSpecificMesDTO) => {
  const { data } = await axios.post(
     `/api/admin/notify/user`,
    dto
  );

  return data;
};
const cancelAppointmentByDate = async (dto: CancelAppointmentByDateDTO) => {
  const { data } = await axios.post(
     `/api/admin/appointment/cancel-by-date`,
    dto
  );
  return data;
};
// Get Online Appointment
const getOnlineAppoinment = async () => {
  const { data } = await axios.get( `/api/referral/doctor/get`);
  return data;
};
const sendOtp = async (dto: SendOtp) => {
  const { data } = await axios.get(
    
      `/api/auth/otp/get?role=${dto.role}&phone_number=${dto.phone_number}`
  );

  return data;
};
const addLabTest = async (dto: AddPLabtestDTO) => {
  const { data } = await axios.post(
     `/api/lab-tests-doc/add`,
    dto
  );
  return data;
};
const addProcedure = async (dto: AddProcedureDTO) => {
  const { data } = await axios.post( `/api/procedures/add`, dto);
  return data;
};
const editLabTest = async (dto: EditLabTesteDTO) => {
  const { data } = await axios.post(
     "/api/lab-tests-doc/edit",
    dto
  );
  return data;
};
const editProcedure = async (dto: EditProcedureDTO) => {
  const { data } = await axios.post( "/api/procedures/edit", dto);
  return data;
};
const deleteProcedure = async (dto: DeleteProcedureDTO) => {
  const { data } = await axios.delete(
    
      `/api/procedures/delete?procedures_id_to_del=${dto.procedures_id_to_del}&clinic_id=${dto.clinic_id}&doctor_id=${dto.doctor_id}`
  );
  return data;
};
const deleteLabTest = async (dto: DeleteLabTestDTO) => {
  const { data } = await axios.delete(
    
      `/api/lab-tests-doc/delete?lab_test_id_to_del=${dto.lab_test_id_to_del}&clinic_id=${dto.doctor_id}`
  );
  return data;
};
const getAllMedicalProcedures = async (dto: GetAllClinicPatientsDTO) => {
  const { data } = await axios.get(
    
      `/api/procedures/view?clinic_id=${dto.clinic_id}&doctor_id=${dto.doctor_id}`
  );
  return data;
};
const getAllLabTest = async (clinic_id: number) => {
  const { data } = await axios.get(
     `/api/lab-tests-doc/view?clinic_id=${clinic_id}`
  );
  return data;
};
const addPayment = async (dto: PaymentAddDTO) => {
  const { data } = await axios.post(
     `/api/appointment/payment/add`,
    dto
  );
  return data;
};
const appointmentsService = {
  getAllAppointments,
  addPayment,
  deleteProcedure,
  deleteLabTest,
  createAppointment,
  addAttachment,
  getAttachments,
  deleteAppointment,
  changeAppointmentStatus,
  deleteAttachments,
  appoinmentHistory,
  addNotes,
  getNotes,
  getInvoice,
  addExpenses,
  getNewlyBookedAppointments,
  getCancelAppointmentRequest,
  cancelAppointmentByDate,
  getDoctorRefferalsRequest,
  getOnlineAppoinment,
  deleteReferalAppointment,
  confirmAppointmentBooking,
  sendSms,
  sendSpecificSms,
  sendEmail,
  sendBulkEmail,
  sendOtp,
  changePaymentStatus,
  addLabTest,
  addProcedure,
  editLabTest,
  editProcedure,
  getAllMedicalProcedures,
  getAllLabTest,
};

export default appointmentsService;
